import { useEffect, useRef } from "react";

export default function useReveal({
  threshold = 0.05,
  rootMargin = "0px 0px -10% 0px",
  once = true,
} = {}) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // SSR / very old browsers: no IntersectionObserver — immediately reveal so
    // content is never permanently hidden.
    if (typeof IntersectionObserver === "undefined") {
      el.classList.add("in-view");
      return;
    }
    el.classList.add("reveal");
    const io = new IntersectionObserver(handleEntries, { threshold, rootMargin });
    io.observe(el);

    function handleEntries(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("in-view");
        if (once) io.unobserve(entry.target);
      });
    }

    return () => io.disconnect();
    // `IntersectionObserver`, `el`, and `entries` are globals or scoped inside
    // the effect — they are intentionally not dependencies. Only the public
    // tuning props belong here.
  }, [threshold, rootMargin, once]);
  return ref;
}
